import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const NotReplacement = () => {
  const { t } = useTranslation();

  return (
    <section 
      id="not-replacement" 
      className="py-10 bg-stone-100"
      data-testid="not-replacement-section"
    >
      <div className="max-w-3xl mx-auto px-6">
        <h2 
          className="text-base font-medium text-stone-700 mb-3"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('notReplacement.headline')}
        </h2>
        <p className="text-stone-600 text-sm leading-relaxed mb-6">
          {t('notReplacement.text')}
        </p>
        
        {/* Betreiber-Info */}
        <div className="pt-4 border-t border-stone-200">
          <p className="text-stone-500 text-xs">
            {t('operator.text')}{' '}
            <Link to="/impressum" className="underline hover:text-[#1B4D3E]">
              {t('operator.linkText')}
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};
